import gql from 'graphql-tag';

export class ActionPlanMutations {
  static updateTask = gql`
    mutation UpdateTask(
      $payload: UpdateTaskInput!
      $taskId: String!
      $milestoneId: String!
      $actionPlanId: String!
    ) {
      updateTask(
        payload: $payload
        taskId: $taskId
        milestoneId: $milestoneId
        actionPlanId: $actionPlanId
      )
    }
  `;
}
